<template>
  <div
    style="width: 100%"
    class="mx-2"
  >
    <v-col cols="12">
      <app-title texto="PREFERÊNCIAS DE TRABALHO" />
    </v-col>
    <v-col
      v-for="f in filtro"
      :key="f.titulo"
      cols="12"
    >
      <filtro-base :value="f" />
    </v-col>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import FiltroBase from '@/components/monitoramento/perfil/filtro/base/FiltroBase';
import FiltroPerfil from '@/modules/filtroPerfil';

export default {
  name: 'FiltroPreferenciaTrabalho',

  components: { AppTitle, FiltroBase },

  data() {
    return {
      filtro: {
        preferencia: {
          habilitado: true,
          filhos: this.$store.state.perfil.preferencias.map((preferencia) => {
            const itens = this.$store.state.perfil.itensPreferencia
              .map((i) => ({
                id: i.id,
                letra: i.letra,
                nome: `${i.letra}. ${i.descricaoAlternativa}`,
                preferencia: i.preferencia,
              }))
              .filter((i) => i.preferencia.id === preferencia.id)
              .sort((a, b) => a.letra.localeCompare(b.letra));
            return {
              id: preferencia.id,
              tipo: 'confirm',
              titulo: `${preferencia.ordem} - ${preferencia.nome}`,
              habilitado: false,
              opcoes: itens.map((i) => ({
                nome: i.nome,
                valor: i,
              })),
              opcao: null,
              horizontal: false,
              colunas: 6,
              filhosDependentes: false,
              filhos: [],
            };
          }),
        },
      },
    };
  },

  watch: {
    filtro: {
      handler() {
        const filtrosPreferencia = this.filtro.preferencia.filhos.map((filtro) => FiltroPerfil.getRetorno(filtro));
        const retorno = {
          habilitado: filtrosPreferencia.reduce((acumulador, filtro) => {
            if (filtro.habilitado) {
              acumulador = true;
            }
            return acumulador;
          }, false),
          lista: filtrosPreferencia,
        };
        this.$emit('return', retorno.habilitado ? retorno : null);
      },
      deep: true,
    },
  },
};
</script>
